import request from '@/utils/request'

export function selectFloor(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/floor/selectFloor?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDateFloor(data) {
    return request({
        url: `api/serviceCenter/floor/upDateFloor`,
        method: 'post',
        data,
    })
}
export function bathDeleteFile(data) {
    return request({
        url: `api/serviceCenter/floor/bathDeleteFile`,
        method: 'post',
        data,
    })
}

export function addFloor(data) {
    return request({
        url: `api/serviceCenter/floor/addFloor`,
        method: 'post',
        data,
    })
}

export function selectCarvingName(data) {
    return request({
        url: `api/serviceCenter/setCarving/selectCarvingName?access=${data}`,
        method: 'post',
    })
}
